"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _semanticUiReact = require("semantic-ui-react");

var _contact = require("../../actions/contact");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// TODO: Move this into Containers folder
var EnquireModal = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(EnquireModal, _React$Component);

  function EnquireModal(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "enquireAndShowThankyou", function () {
      var formData = _this.state.formData;
      formData.industryOfInterest = _this.props.industryOfInterest;

      _this.props.premiumDataEnquiry(formData);
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (event) {
      var formData = Object.assign({}, _this.state.formData);
      formData[event.target.name] = event.target.value;

      _this.setState({
        formData: formData
      });
    });

    _this.state = {
      open: false,
      formData: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        organisation: '',
        industryOfInterest: '',
        comment: ''
      }
    };
    return _this;
  }

  var _proto = EnquireModal.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        enquiryError = _this$props.enquiryError,
        enquirySent = _this$props.enquirySent,
        isFetching = _this$props.isFetching,
        open = _this$props.open,
        closeModal = _this$props.closeModal;
    return /*#__PURE__*/React.createElement(_semanticUiReact.Modal, {
      open: open,
      onClose: closeModal,
      closeOnEscape: true,
      closeOnDimmerClick: true,
      centered: false,
      id: "industry-data-modal",
      closeIcon: /*#__PURE__*/React.createElement("button", {
        className: "modal__close"
      }, "Close")
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Modal.Header, {
      className: "industry-data-modal--header"
    }, "Industry Data Packs Enquiry"), !enquirySent && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_semanticUiReact.Modal.Content, {
      className: "industry-data-modal--content"
    }, /*#__PURE__*/React.createElement("p", null, "Your current subscription doesn\u2019t include access to this data."), /*#__PURE__*/React.createElement("p", null, "Just complete the contact form below and someone will come straight back to you with our pricing."), /*#__PURE__*/React.createElement("p", null, " You\u2019ll be pleasantly surprised."), /*#__PURE__*/React.createElement(_semanticUiReact.Form, {
      onSubmit: this.enquireAndShowThankyou.bind(this),
      className: "login-form__form"
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Grid, null, /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Row, {
      className: "industry-data-modal--row"
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Column, {
      width: 6
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Form.Input, {
      required: true,
      label: "First Name",
      name: "firstName",
      type: "text",
      onChange: this.handleInputChange,
      disabled: isFetching
    })), /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Column, {
      width: 6
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Form.Input, {
      required: true,
      label: "Last Name",
      name: "lastName",
      type: "text",
      onChange: this.handleInputChange,
      disabled: isFetching
    }))), /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Row, {
      className: "industry-data-modal--row"
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Column, {
      width: 6
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Form.Input, {
      required: true,
      label: "Email",
      name: "email",
      type: "email",
      onChange: this.handleInputChange,
      disabled: isFetching
    })), /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Column, {
      width: 6
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Form.Input, {
      required: true,
      label: "Phone",
      name: "phone",
      type: "tel",
      onChange: this.handleInputChange,
      disabled: isFetching
    }))), /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Row, {
      className: "industry-data-modal--row"
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Column, {
      width: 6
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Form.Input, {
      label: "Organisation",
      name: "organisation",
      type: "text",
      onChange: this.handleInputChange,
      disabled: isFetching
    })), /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Column, {
      width: 6
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Form.Input, {
      name: "industryOfInterest",
      type: "hidden",
      onChange: this.handleInputChange,
      disabled: isFetching,
      value: this.props.industryOfInterest
    }))), /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Row, {
      className: "industry-data-modal--row"
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Column, {
      width: 12
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Form.TextArea, {
      className: "industry-data-modal--comment",
      label: "Comment",
      name: "comment",
      type: "textarea",
      onChange: this.handleInputChange,
      disabled: isFetching,
      rows: 3
    }))), /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Row, null, /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Column, {
      width: 12,
      style: {
        textAlign: 'right'
      }
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Button, {
      onClick: closeModal,
      negative: true
    }, "No Thanks"), "\xA0", /*#__PURE__*/React.createElement(_semanticUiReact.Form.Button, {
      as: _semanticUiReact.Button,
      type: "submit"
    }, "Enquire now"))))))), enquirySent && /*#__PURE__*/React.createElement(React.Fragment, null, !enquiryError && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_semanticUiReact.Modal.Content, null, "Thank you for contacting us, we'll be in touch shortly.")), enquiryError && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_semanticUiReact.Modal.Content, null, "Unfortunately there has been an error. Please email us directly at", ' ', /*#__PURE__*/React.createElement("a", {
      href: "mailto:live@roymorgan.com"
    }, "live@roymorgan.com"), "."))));
  };

  return EnquireModal;
}(React.Component); // get something out of global store


var mapStateToProps = function mapStateToProps(state, props) {
  return {
    enquiryError: state.contact.error,
    enquirySent: state.contact.fetched,
    isFetching: state.contact.isFetching
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    premiumDataEnquiry: _contact.premiumDataEnquiry,
    premiumDataEnquiryReset: _contact.premiumDataEnquiryReset
  }, dispatch);
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EnquireModal);

exports["default"] = _default;